// Code splitting calls use promises internally.
import { isNil } from '@flowio/is';
import 'core-js/es/promise';

const polyfillPromises: Promise<void>[] = [];

function isES2017Compliant(): boolean {
  return 'values' in Object;
}

function loadStandardLibrary(): Promise<void> {
  return import(
    /* webpackChunkName: "polyfill-standard-library" */
    /* webpackPreload: true */
    'core-js/es'
  );
}

function loadFetch(): Promise<void> {
  return import(
    /* webpackChunkName: "polyfill-fetch" */
    /* webpackPreload: true */
    'whatwg-fetch'
  );
}

if (!isES2017Compliant()) {
  polyfillPromises.push(loadStandardLibrary());
}

if (!global.fetch) {
  polyfillPromises.push(loadFetch());
}

/**
 * @description This `payment` named export is used in conjunction with the webpack configuration
 * to output the library to the global variable `flow`. The name of the object output here dictates
 * the property name on the `window.flow` object. It will overwrite anything within the
 * `window.flow.payment`namespace, but it is considered a safe assumption that this library owns
 * that namespace.
 * @see https://webpack.js.org/configuration/output/#type-assign-properties-badge-text5160-
 */
export * as payment from './index';

// call ready handler afterward if it is present
window.setTimeout(() => {
  const readyFunction = window.onFlowPaymentReady;
  if (!isNil(readyFunction)) {
    Promise.all(polyfillPromises).then(() => readyFunction());
  }
}, 0);
